window.addEventListener("load", function () {
  const $section = $("#lan-ld-26-a-character");

  if ($section.length === 0) {
    return;
  }

  const players = new Map();
  let currentPlayer = null;

  const getPlayer = function (src) {
    if (players.has(src)) {
      return players.get(src);
    }

    const player = new Audio(src);
    player.preload = "auto";
    players.set(src, player);
    return player;
  };

  $section
    .off("click.characterSound", ".sound__character")
    .on("click.characterSound", ".sound__character", function (event) {
      event.preventDefault();

      const $button = $(this);
      const source = $button.data("sound");

      if (!source) {
        return;
      }

      const src = String(source);
      const targetPlayer = getPlayer(src);

      // Pause background music khi nghe character sound
      var bgMusic = document.getElementById("backgroundMusic");
      if (bgMusic && !bgMusic.paused) {
        bgMusic.pause();
        $(".music").addClass("offmusic");
      }

      if (
        currentPlayer &&
        currentPlayer === targetPlayer &&
        !currentPlayer.paused
      ) {
        currentPlayer.pause();
        currentPlayer.currentTime = 0;
        currentPlayer = null;
        return;
      }

      if (currentPlayer && currentPlayer !== targetPlayer) {
        currentPlayer.pause();
        currentPlayer.currentTime = 0;
      }

      targetPlayer.currentTime = 0;
      currentPlayer = targetPlayer;

      targetPlayer.play().catch(function () {
        currentPlayer = null;
      });
    });
});
